module.exports = __webpack_public_path__ + "assets/df5d35d43f2d25e464ca280e7c6819b3.png";